const tParams = 'group_contact.file_upload_modal';
export const params = {
  'phone': {title: tParams + '.params_phone', bg: ''},
  'name': {title: tParams + '.params_name', bg: 'badge-primary'},
  'first_name': {title: tParams + '.params_first_name', bg: 'badge-primary'},
  'second_name': {title: tParams + '.params_second_name', bg: 'badge-primary'},
  'last_name': {title: tParams + '.params_last_name', bg: 'badge-primary'},
  'birth_day': {title: tParams + '.params_birth_day', bg: 'bg-violet-300'},
  'code': {title: tParams + '.params_code', bg: 'bg-purple-300'},
  'email': {title: tParams + '.params_email', bg: 'bg-indigo-300'},
  'date': {title: tParams + '.params_date', bg: 'bg-orange-300'},
  'sum': {title: tParams + '.params_sum', bg: 'bg-teal'},
  'param_1': {title: tParams + '.params_param_1', bg: 'bg-info'},
  'param_2': {title: tParams + '.params_param_2', bg: 'bg-info'},
  'param_3': {title: tParams + '.params_param_3', bg: 'bg-info'},
};

export const SEPARATE_SYMBOL_COMMA = 'comma';
export const SEPARATE_SYMBOL_SEMICOLON = 'semicolon';

export const PHONES_SOURCE_FILE = 'file';
export const PHONES_SOURCE_TEXTAREA = 'textarea';
